import Checkbox from './checkbox';
import FileInput from './file';
import SimpleInput, { Input } from './input';
import MahallaAutocomplete from './mahalla'
import MaskedInput from './mask-input';
import RadioButton from './radio';
import RadioPublicButton from './radio-public';
import SelectInput, { makeSelectInput, Select } from './select';
import Textarea from './textarea';

export { Checkbox, FileInput, SimpleInput, MaskedInput, RadioButton, RadioPublicButton, SelectInput, Textarea, Input, makeSelectInput, Select, MahallaAutocomplete };



// WEBPACK FOOTER //
// ./src/application-form/field-components/index.js